export const CustomerDetailValidation = (formData) => {
    const errors = {};

    if (!formData.formData.CompanyName || !formData.formData.CompanyName.trim()) {
        errors.CompanyName = 'This field is required';
    }
    if (!formData.formData.Forename || !formData.formData.Forename.trim()) {
        errors.Forename = 'This field is required';
    }

    if (!formData.formData.Surname || !formData.formData.Surname.trim()) {
        errors.Surname = 'This field is required';
    }
    if (!formData.formData.Address1 || !formData.formData.Address1.trim()) {
        errors.Address1 = 'This field is required';
    }
    if (formData.formData.Email) {
        if (!isValidEmail(formData.formData.Email)) {
            errors.Email = 'Please enter a valid email address';
        }
    }
    if (formData.formData.CompanyEmail) {
        if (!isValidEmail(formData.formData.CompanyEmail)) {
            errors.CompanyEmail = 'Please enter a valid email address';
        }
    }
    

    return errors;
};
const isValidEmail = (email) => {
    // You can implement a regex or use a library like validator.js to validate email format
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
};
